import { render, staticRenderFns } from "./view-material.vue?vue&type=template&id=a6d64f02&scoped=true&"
import script from "./view-material.vue?vue&type=script&lang=ts&"
export * from "./view-material.vue?vue&type=script&lang=ts&"
import style0 from "./view-material.vue?vue&type=style&index=0&id=a6d64f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d64f02",
  null
  
)

export default component.exports